const url = require('url')

/**
 * Given a url for redirecting (like after login), determine
 * whether or not it's safe to be used as a redirect.
 *
 * Examples of unsafe redirects:
 * - ///workout/create
 * - http:///example.com
 * - https://www.google.com
 * - //malicious.com
 * - c:\malicious.exe
 * - \t///example.com
 *
 * @param  {String}  url - requested url for redirect
 * @return {Boolean}
 */
function isSafeRedirect (_url) {
  const allowedProtocols = [
    'http:',
    'https:',
  ]

  const allowedHosts = [
    'local.mapmyrun.com',
    'local.mapmywalk.com',
    'local.mapmyride.com',
    'local.mapmyhike.com',
    'local.mapmyfitness.com',
    'staging.mapmyfitness.com',
    'devint.mapmyfitness.com',
    'www.mapmyrun.com',
    'www.mapmyride.com',
    'www.mapmywalk.com',
    'www.mapmyhike.com',
    'www.mapmyfitness.com',
    'www.endomondo.com',
    'record.underarmour.com',
    'staging-record.underarmour.com',
    'www.myfitnesspal.com',
    'itunes.apple.com',
    'play.google.com',
    'preprod-uarunweb-web.uacf.io',
    'uarun.cn',
  ]

  if (!_url || typeof _url !== 'string') { return false }

  // Treat any url with three slashes as unsafe.
  if (_url.indexOf('///') === 0) { return false }

  // Forbid URLs that start with control characters. Some browsers (like
  // Chrome) ignore quite a few control characters at the start of a
  // URL and might consider the URL as scheme relative.
  if (_url[0].match(/[^\x20-\x7E]+/g)) { return false }

  // Chrome treats \ completely as /
  const __url = _url.trim().replace(/\\/g, '/')

  const parsed = url.parse(__url)

  // Forbid URLs like http:///example.com - with a scheme, but without a hostname.
  // In that URL, example.com is not the hostname but, a path component. However,
  // Chrome will still consider example.com to be the hostname, so we must not
  // allow this syntax.
  if (!parsed.host && parsed.protocol) {
    return false
  }

  const safeHostname = !parsed.hostname || allowedHosts.includes(parsed.hostname)
  const safeProtocol = !parsed.protocol || allowedProtocols.includes(parsed.protocol)

  return safeHostname && safeProtocol
}

function ensureAbsoluteUrl (target, protocol, host) {
  const isRelative = target[0] === '/'
  return isRelative ? `${protocol}://${host}${target}` : target
}

function getSafeRedirect (href, protocol, host, defaultPath = '/') {
  const target = isSafeRedirect(href) ? href : defaultPath
  const _protocol = protocol.replace(':', '')
  const safeUrl = ensureAbsoluteUrl(target, _protocol, host)
  return safeUrl
}

module.exports = {
  isSafeRedirect: isSafeRedirect,
  getSafeRedirect: getSafeRedirect,
  ensureAbsoluteUrl: ensureAbsoluteUrl,
}
